import {Typed} from "app/stimulus/typed-stimulus";
import {Controller} from "@hotwired/stimulus";
import SideMenu from "components/Admin/SideMenu/Menu/menu-controller";
import {AsStimulusController} from "app/stimulus/as-stimulus-controller";

@AsStimulusController('admin-top-menu')
export default class extends Typed(Controller<HTMLElement>)
{
    public async openSideMenu(): Promise<void> {
        const sideMenuEl = document.getElementById('admin_side_menu');
        if (sideMenuEl === null) {
            console.error('Side menu element not found');
            return;
        }
        const sideMenu = await SideMenu.getAsync(sideMenuEl);
        sideMenu?.open();
    }
}
